/* List of Redux constants */
export const PASSWORD_RECOVERY_SET_FORGOT_PASSWORD_LOADING = '@password-recovery/set-forgot-password-loading';
export const PASSWORD_RECOVERY_SET_RESET_PASSWORD_LOADING = '@password-recovery/set-reset-password-loading';
export const PASSWORD_RECOVERY_SET_RECOVERY_REQUEST_HAS_BEEN_SENT_TO_EMAIL = '@password-recovery/set-recovery-request-has-been-sent-to-email';
export const PASSWORD_RECOVERY_RESET_FORGOT_PASSWORD_STATE = '@password-recovery/reset-forgot-password-state';
export const PASSWORD_RECOVERY_SET_RECOVERY_REQUEST_FAILED_REASON = '@password-recovery/set-recovery-request-failed-reason';
export const PASSWORD_RECOVERY_RESET_RESET_PASSWORD_STATE = '@password-recovery/reset-reset-password-state'
export const PASSWORD_RECOVERY_SET_PASSWORD_SUCCEFULLY_CHANGED = '@password-recovery/set-password-succefull-changed'
export const PASSWORD_RECOVERY_SET_CODE_IS_EXPIRED_OR_USED = '@password-recovery/set-code-is-expired-or-used'
export const PASSWORD_RECOVERY_SET_CODE_IS_NOT_FOUND = '@password-recovery/set-code-is-not-found'

/* List of Sagas constants */
export const PASSWORD_RECOVERY_SEND_RECOVERY_REQUEST = '@password-recovery/send-recovery-request';
export const PASSWORD_RECOVERY_SEND_RESET_EMAIL = '@password-recovery/send-reset-email';
export const PASSWORD_RECOVERY_VALIDATE_RESET_PASSWORD_CODE = '@password-recovery/validate-reset-password-code';
export const PASSWORD_RECOVERY_RESET_PASSWORD = '@password-recovery/reset-password';



// WEBPACK FOOTER //
// ./src/actions/password-recovery/types.js